import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-left-side-panel',
  templateUrl: './left-side-panel.component.html',
  styleUrls: ['./left-side-panel.component.scss']
})
export class LeftSidePanelComponent {
  @Input() isOpen: boolean = false; // Control the panel's visibility
  @Input() title: string = '';      // Title of the panel
  @Output() close = new EventEmitter<void>(); // Event for panel close
  @Input() cancelButtonLabel: string = 'Cancel'; // Label for cancel button
  @Input() submitButtonLabel: string = 'Submit'; // Label for submit button
  @Output() cancel = new EventEmitter<void>();   // Event for cancel button
  @Output() submit = new EventEmitter<void>();   // Event for submit button

  onClose() {
    this.close.emit();
  }

  onCancel() {
    this.cancel.emit();
  }

  onSubmit() {
    this.submit.emit();
  }
}
